import { render, staticRenderFns } from "./dont-have-username.vue?vue&type=template&id=efc6cad0&scoped=true&"
import script from "./dont-have-username.vue?vue&type=script&lang=js&"
export * from "./dont-have-username.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=efc6cad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc6cad0",
  null
  
)

component.options.__file = "dont-have-username.vue"
export default component.exports